import React from 'react';
import { CheckCircle, Clock, Zap } from 'lucide-react';

const STATUS_STYLES = {
  success: { wrap: 'bg-green-500/10 border-green-500/30', text: 'text-green-400', Icon: CheckCircle },
  processing: { wrap: 'bg-blue-500/10 border-blue-500/30', text: 'text-blue-400', Icon: Clock },
};

const FAILURE_STYLE = { wrap: 'bg-red-500/10 border-red-500/30', text: 'text-red-400', Icon: Zap };

export const PaymentStatusBanner = ({ status, message, onDismiss }) => {
  if (!status) return null;
  const { wrap, text, Icon } = STATUS_STYLES[status] || FAILURE_STYLE;
  return (
    <div className={`mb-6 p-4 rounded-xl flex items-center gap-3 border ${wrap}`} data-testid="payment-status-banner">
      <Icon className={`w-5 h-5 ${text} ${status === 'processing' ? 'animate-pulse' : ''}`} />
      <span className={`text-sm ${text}`}>{message}</span>
      {status === 'success' && (
        <button
          onClick={onDismiss}
          className="ml-auto text-gray-400 hover:text-white"
          data-testid="payment-banner-dismiss"
          aria-label="Dismiss"
        >
          ✕
        </button>
      )}
    </div>
  );
};
